import { checkInValidAnswer } from "../shared/AppFormHelper";
import {
    IAnswerProps,
    IAppFormQuestion
} from "../interfaces/IAppFormData";
import { IAppFormSelectors } from "./useAppFormState";
import { getDataLayerInfo } from "../api/ApiAppForm";


interface IUseAppFormUtils {
    checkFormList: (
        questionList: Array<IAppFormQuestion>,
        answerList: Array<IAnswerProps>,
        selectors?: IAppFormSelectors
    ) => boolean;
    checkFormCheckList: (answerList: Array<IAnswerProps>) => boolean;
    checkSearchTerm: (search: string) => boolean;
    createAnswerList: (
        questionList: Array<IAppFormQuestion>,
        formAnswerList: Array<IAnswerProps>,
        answerParam: IAnswerProps
    ) => Array<IAnswerProps>;
	getGenderString: (gender: number) => string;
    populateDataLayer: (applicationId: number, quoteGroupId: string) => void;
    validDOB: (question: IAppFormQuestion, date: string) => string;
    validEmail: (email: string) => boolean;
}



export function useAppFormUtils(): IUseAppFormUtils {

	const checkFormList = (questionList, answerList, selectors): boolean => {
		return questionList.reduce((acc, item) => {
			const formAnswer =
				selectors && item?.id === 1
					? selectors?.getEachFormData(item.id)?.answer ?? ""
					: "";
			const answerValue = answerList.find((i) => i.questionId === item.id);
			const answer = answerValue?.answer ?? formAnswer;
			const isFieldRequired =
				item?.required === undefined || item?.required === null || item?.required;
			if (isFieldRequired === true && checkInValidAnswer(answer)) {
				acc = false;
			}
			return acc;
		}, true);
	};


	const checkFormCheckList = (answerList): boolean => {
		return answerList.reduce((acc, item) => {
			if (item?.answer === "Yes") {
				acc = true;
			}
			return acc;
		}, false);
	}


	const checkSearchTerm = (search: string) : boolean => {
		if ((search.length > 0 && search.length < 3) || search.length > 200) {
			return false
		}
		return true;
	}


	const createAnswerList = (questionList, formAnswerList, answerParam): Array<IAnswerProps> => {
		return questionList.reduce((acc, item) => {
			const currentAnswer = formAnswerList.find((i) => i.questionId === item.id);
			const answer =
				answerParam.questionId === item.id
					? answerParam.answer
					: currentAnswer?.answer;

			return [
				...acc,
				{
					questionId: item.id,
					disclosure: [],
					answer
				}
			];
		}, []);
	}


	const getGenderString = (gender: number) : string => {
		switch (Number(gender)) {
			case 1:
				return "male";
			case 2:
				return "female";
			default:
				return "unknown";
		}
	}


	const populateDataLayer = (applicationId: number, quoteGroupId: string) : void => {
		window.dataLayer = window.dataLayer || [];
		getDataLayerInfo(applicationId, quoteGroupId)
			.then((res) => {
				window.FamilyID = res.familyId;
				window.dataLayer.push({
					"FamilyID": res.familyId,
					"AppID": res.appId,
					"VisitorID": res.visitorId,
					"CollectionID": res.collectionId,
					"InsurerName": res.insurerName,
					"API": res.api,
					"CurrentPageProgress": res.currentPageProgress,
					"Benefits": res.benefits
				});
			});
	}


	const validDOB = (question, date): string => {
		const errorMessage = `Please provide a date from ${question?.rangeStart} to ${question?.rangeEnd} years old`;
		if ((!question?.rangeStart && question?.rangeStart !== 0) || !question?.rangeEnd) return "";
		const datePicked = new Date(date);
		if (datePicked.toDateString() === new Date().toDateString()) {
			return errorMessage;
		}
		var diff_ms = Date.now() - datePicked.getTime();
		if (diff_ms < 0) {
			return errorMessage;
		}
		var age_dt = new Date(diff_ms);

		const age = Math.abs(age_dt.getUTCFullYear() - 1970);
		if (age >= question?.rangeStart && age <= question?.rangeEnd) return "";
		return errorMessage;
	}


	const validEmail = (email): boolean => {
		return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
	}
	

    return {
        checkFormList,
        checkFormCheckList,
        checkSearchTerm,
        createAnswerList,
        getGenderString,
        populateDataLayer,
        validDOB,
        validEmail
    };
};

